(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/bank/assets/javascripts/shared.js') >= 0) return;  svs.modules.push('/components/ui/bank/assets/javascripts/shared.js'); "use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }


var svs = svs || {};

(function (svs) {
  'use strict';

  var isServerSide = (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object',
      config;

  if (isServerSide) {
    var trinidad = require('trinidad-core').core;

    config = trinidad.config;
  } else {
    config = {
      options: svs.core.config.data.svsconfig
    };
  }

  svs.ui = svs.ui || {};
  svs.ui.bank = svs.ui.bank || {};
  var path = '/images/ui/bank/',
      hashedFiles = {
    'masterpass': 'masterpass-284-09cf062bec482f42c06ebda5044d3ce5343eb1dd.png',
    'masterpass-24': 'masterpass-24-dbfb2fffaf887e6ed4d444b48a462887d7a67c3a.png',
    'masterpass-36': 'masterpass-36-4957b50639f4ed172205512351b0503961ebc5af.png',
    'masterpass-48': 'masterpass-48-bef2b47a57a9ede43b2348a2a375a7b416ab1fd2.png',
    'masterpass-72': 'masterpass-72-632f5355db5fd685bc4d2eafc7074d7eed95e98f.png',
    'masterpass-96': 'masterpass-96-420a27330447b29f8e6fc3060ac6232fe0605d2e.png',
    'masterpass-142': 'masterpass-142-fb7f7ed6272283758fbd87dd0dc133c9a3d1c172.png',
    'masterpass-192': 'masterpass-192-098a703354e2981397b3e880d8ed31155bbdfb74.png',
    'masterpass-284': 'masterpass-284-09cf062bec482f42c06ebda5044d3ce5343eb1dd.png',
    'bankgirot': 'bankgirot-284-6f3bce4f8c9a96461679088f4c5e6757a05bfa45.png',
    'bankgirot-24': 'bankgirot-24-d9e85d8d99b1d0b5c27a451b0dff1bd1956772ce.png',
    'bankgirot-36': 'bankgirot-36-d239ecc1649fd06d0ec5bdb8e1aa2e2914c4c9bf.png',
    'bankgirot-48': 'bankgirot-48-942275abbb334702cac3de6acdcb37147692924d.png',
    'bankgirot-72': 'bankgirot-72-3045b368dfababb2f9783219d6a769f3bfa8be03.png',
    'bankgirot-96': 'bankgirot-96-d71fb1f156030806723046e5ab5c13f61d321f35.png',
    'bankgirot-142': 'bankgirot-142-7504ed3065a5eccd11dc2bac56c72aae451dcfd9.png',
    'bankgirot-192': 'bankgirot-192-a41564b36db862df24343909b976bb19ea92686a.png',
    'bankgirot-284': 'bankgirot-284-6f3bce4f8c9a96461679088f4c5e6757a05bfa45.png',
    'bankid-promo': 'bankid-promo-284-644c9267d70ee34cff8772554e5c01a1f26a21cf.png',
    'bankid-promo-24': 'bankid-promo-24-1a3277b209c10c722029e04309fa96bf71ac575c.png',
    'bankid-promo-36': 'bankid-promo-36-57b1fe13b5a4deb88de17eeb66217c6a7a58457d.png',
    'bankid-promo-48': 'bankid-promo-48-86b2869be9a7f865bb061da5613bf5d18c07520b.png',
    'bankid-promo-72': 'bankid-promo-72-ef34cf784af494b01c60e548e56716e6beb9823d.png',
    'bankid-promo-96': 'bankid-promo-96-1cd230f6e6148dc57253dc0fb8991dee299a6ad6.png',
    'bankid-promo-142': 'bankid-promo-142-5404314ad31392e3187d93d40a5aa5c115c0c419.png',
    'bankid-promo-192': 'bankid-promo-192-ac6760564524a50a5d8bb60ce9be8e1dafc80957.png',
    'bankid-promo-284': 'bankid-promo-284-644c9267d70ee34cff8772554e5c01a1f26a21cf.png',
    'freja-eid-neg': 'freja-eid-neg-284-36f6bc84965e3d64930dc361230adec577e14b3a.png',
    'freja-eid-neg-24': 'freja-eid-neg-24-3c9349ffa8047a0e063c14e4479f8cc75e083a1b.png',
    'freja-eid-neg-36': 'freja-eid-neg-36-da7e38c2f5baef77f21dd4674b3513880615d870.png',
    'freja-eid-neg-48': 'freja-eid-neg-48-57cdc88b7ff796fa12778f7c3619e92f1e389a20.png',
    'freja-eid-neg-72': 'freja-eid-neg-72-576f66c29f87ad5be84d562029c8453eade3aae7.png',
    'freja-eid-neg-96': 'freja-eid-neg-96-8f3f4efefe3d204ace3b68023849f0dbced5ab61.png',
    'freja-eid-neg-142': 'freja-eid-neg-142-4f9233535170a4dbff6b1e94009131264779ca9a.png',
    'freja-eid-neg-192': 'freja-eid-neg-192-36b5fe572aa624632d6cd3fd461bea2141a3ab95.png',
    'freja-eid-neg-284': 'freja-eid-neg-284-36f6bc84965e3d64930dc361230adec577e14b3a.png',
    'freja-eid-vertical-neg': 'freja-eid-vertical-neg-284-49b5b4f1c071a5b40a7157a3a29541f7c9387f47.png',
    'freja-eid-vertical-neg-24': 'freja-eid-vertical-neg-24-8be66ed2ec37b9fef8795b088d64c52f1aea2f2b.png',
    'freja-eid-vertical-neg-36': 'freja-eid-vertical-neg-36-5a359cb3fbd4a76268c99a734fb17a47bc4c3d20.png',
    'freja-eid-vertical-neg-48': 'freja-eid-vertical-neg-48-4b3dcf066160c9835055f12ada8bfe8732eb4382.png',
    'freja-eid-vertical-neg-72': 'freja-eid-vertical-neg-72-697f686e2084957a231bdc538671da34fe1f8a8f.png',
    'freja-eid-vertical-neg-96': 'freja-eid-vertical-neg-96-1802787f827dc237325b630738a71df6f7594bbb.png',
    'freja-eid-vertical-neg-142': 'freja-eid-vertical-neg-142-b25286f2615bb212bba18cdb00bc799e0c8f3f32.png',
    'freja-eid-vertical-neg-192': 'freja-eid-vertical-neg-192-f1a8c513d42f88cbe43367607492cf49e7cd64d1.png',
    'freja-eid-vertical-neg-284': 'freja-eid-vertical-neg-284-49b5b4f1c071a5b40a7157a3a29541f7c9387f47.png',
    'freja-eid-vertical': 'freja-eid-vertical-284-865dd9e89ca857388f284f2930c8fa38b456aed1.png',
    'freja-eid-vertical-24': 'freja-eid-vertical-24-221b768bed7df1bad771800aae18f04b4941fae2.png',
    'freja-eid-vertical-36': 'freja-eid-vertical-36-d112a5bb802abcdc70a667c95a23d0e2891c08f6.png',
    'freja-eid-vertical-48': 'freja-eid-vertical-48-fc9f5511f04b66a028c512fa2db2ca44af087dab.png',
    'freja-eid-vertical-72': 'freja-eid-vertical-72-e6e6005b2e783de831e2e2a9f03ba78b9cf5469b.png',
    'freja-eid-vertical-96': 'freja-eid-vertical-96-71df6c3bc58b825af2b80998fec7044e8afaaa93.png',
    'freja-eid-vertical-142': 'freja-eid-vertical-142-106aae3ed6a7545d07f458dae96d9404a826bc28.png',
    'freja-eid-vertical-192': 'freja-eid-vertical-192-3094aa1c8d9971a242f81416e2f8153642373fd6.png',
    'freja-eid-vertical-284': 'freja-eid-vertical-284-865dd9e89ca857388f284f2930c8fa38b456aed1.png',
    'freja-eid': 'freja-eid-284-0fa5d2fbfad57c4a19989ec8303c4a83735ca59e.png',
    'freja-eid-24': 'freja-eid-24-16ec86935172da4c43cdbb707dc6e4f01b76e4eb.png',
    'freja-eid-36': 'freja-eid-36-bdc4b05c983310b7e28bd9d5c405083abf01448d.png',
    'freja-eid-48': 'freja-eid-48-78855e4038889f38fb8f30ad163554ec30ea1d65.png',
    'freja-eid-72': 'freja-eid-72-39f85aea47fb78c614b0324c577593da0e10f90d.png',
    'freja-eid-96': 'freja-eid-96-ab6b7d05eda5f3b0fd45e5c0226a46371d532513.png',
    'freja-eid-142': 'freja-eid-142-6ec54d5765c76995fcb170da4e7cca5887d1a8eb.png',
    'freja-eid-192': 'freja-eid-192-c033b40c08251049dd32a21cd767eeed2ddfeb34.png',
    'freja-eid-284': 'freja-eid-284-0fa5d2fbfad57c4a19989ec8303c4a83735ca59e.png',
    'handelsbanken': 'handelsbanken-284-97b1db4e918f9cfb0ec93f8ef87ef8731639d0a1.png',
    'handelsbanken-24': 'handelsbanken-24-cd24a4117f8adfe71aaade6045f36afa5e57424b.png',
    'handelsbanken-36': 'handelsbanken-36-48208d2a7cfe15a97a4e6732de64665af16cc389.png',
    'handelsbanken-48': 'handelsbanken-48-657191580efa3b770cea6f0d12752e28249433b8.png',
    'handelsbanken-72': 'handelsbanken-72-9e9c78d19664d3cfa363eaf49baa105192e1732b.png',
    'handelsbanken-96': 'handelsbanken-96-52fd492acba6d5572cb71ae3865491410e37132f.png',
    'handelsbanken-142': 'handelsbanken-142-ff90050ac96097561de8e8aebc3eefb54b30841e.png',
    'handelsbanken-192': 'handelsbanken-192-9d4c3ba055e197f9662acdaeb45fb81379e33a3b.png',
    'handelsbanken-284': 'handelsbanken-284-97b1db4e918f9cfb0ec93f8ef87ef8731639d0a1.png',
    'mastercard': 'mastercard-284-93530a800a1a0ba794ac3e4204cf937527a6ba7a.png',
    'mastercard-24': 'mastercard-24-4922065ca408eeb66f772cc14ddae6c9fa685124.png',
    'mastercard-36': 'mastercard-36-dfcc78f69009fc915509bf91efabe9c9270f5a50.png',
    'mastercard-48': 'mastercard-48-a690565a933f8719a92c603c668d2c4f70ce08a4.png',
    'mastercard-72': 'mastercard-72-cddf3f4b38d4dbc93c5c95363fe4032f82bfd9bf.png',
    'mastercard-96': 'mastercard-96-e2b0d587bc0425fb9363f2572145ab6bed469a93.png',
    'mastercard-142': 'mastercard-142-60d7e56bf47394250fc030c80ad68697ee4d2aff.png',
    'mastercard-192': 'mastercard-192-684f0820f7691ae4f7be5919c7f075e56d1610a2.png',
    'mastercard-284': 'mastercard-284-93530a800a1a0ba794ac3e4204cf937527a6ba7a.png',
    'mastercardsecurecode': 'mastercardsecurecode-284-42c8b999aae9b48e5f0f2c2bb9221ec1e8f0d657.png',
    'mastercardsecurecode-24': 'mastercardsecurecode-24-2d7d69a744ce1ced5d185d4464a598b6598067d4.png',
    'mastercardsecurecode-36': 'mastercardsecurecode-36-62a57718f961c2bf4540aabfea890c48e5de02ea.png',
    'mastercardsecurecode-48': 'mastercardsecurecode-48-a11b3d7df53fbcbdafd87e36e564b4a4fa0073d6.png',
    'mastercardsecurecode-72': 'mastercardsecurecode-72-49cef32720bae2a3357aec6998ef6ca2426deb96.png',
    'mastercardsecurecode-96': 'mastercardsecurecode-96-96a67895552554432b8b84154f766977fe1f9f8f.png',
    'mastercardsecurecode-142': 'mastercardsecurecode-142-b782fd2ddb283b9e9ab562efcf6069677b2d4202.png',
    'mastercardsecurecode-192': 'mastercardsecurecode-192-3146974a8ee6ee764a0628bd0ae124235039b910.png',
    'mastercardsecurecode-284': 'mastercardsecurecode-284-42c8b999aae9b48e5f0f2c2bb9221ec1e8f0d657.png',
    'masterpass-neg': 'masterpass-neg-284-723ccb2939d988dc4ef4d40a5a626cccd39a3599.png',
    'masterpass-neg-24': 'masterpass-neg-24-a94d89f10ba6eebcfb237d5fd16c32fe4a62a475.png',
    'masterpass-neg-36': 'masterpass-neg-36-47dcea5301850b45e9018e870b238caeb077bdca.png',
    'masterpass-neg-48': 'masterpass-neg-48-6368e6e1c181b6a64f6d799e5356238e46225097.png',
    'masterpass-neg-72': 'masterpass-neg-72-df90a19044ba302ce2c776b1483191ebfcc38c1d.png',
    'masterpass-neg-96': 'masterpass-neg-96-da725b22015ea7863ae10440796259e75d2ec59a.png',
    'masterpass-neg-142': 'masterpass-neg-142-679962e35eb8c291291289e0202a90c2f2b335f4.png',
    'masterpass-neg-192': 'masterpass-neg-192-4730ca3a810e1a1a92e7234a3555a4a16c59a31e.png',
    'masterpass-neg-284': 'masterpass-neg-284-723ccb2939d988dc4ef4d40a5a626cccd39a3599.png',
    'masterpass-promo': 'masterpass-promo-284-15858baa64cc899c8012c9756f59f00ab6cd2fa2.png',
    'masterpass-promo-24': 'masterpass-promo-24-61ea1a7b4adb0abb7aeab841d8ff844b84840a15.png',
    'masterpass-promo-36': 'masterpass-promo-36-f0902ffefb4d1ae5f6868d4e37b9757b6f8f4787.png',
    'masterpass-promo-48': 'masterpass-promo-48-5ca08586e0497e08093641379afe336a76cd0cc1.png',
    'masterpass-promo-72': 'masterpass-promo-72-85d7c36af5430783911fb55baa058ad47a7e00e7.png',
    'masterpass-promo-96': 'masterpass-promo-96-ff1a1b2ff95f9d21f835170a4667ed33759330fa.png',
    'masterpass-promo-142': 'masterpass-promo-142-3529ae0171639b8a508c336b9d4a00852d4a3215.png',
    'masterpass-promo-192': 'masterpass-promo-192-3905b490cd789238f75d8f320e66c2fe3245e9bc.png',
    'masterpass-promo-284': 'masterpass-promo-284-15858baa64cc899c8012c9756f59f00ab6cd2fa2.png',
    'bankid-neg': 'bankid-neg-284-2e79bf8378b9ba68f45d0086c6f9171a5ca4d944.png',
    'bankid-neg-24': 'bankid-neg-24-b56df6fc5c3eada16d9ea8bf2317123abcce32d5.png',
    'bankid-neg-36': 'bankid-neg-36-4ca7c5093edc57e02422f56e08cf24ec3737114d.png',
    'bankid-neg-48': 'bankid-neg-48-70f75c3c6682dbfa39c872b256c41e3e38de7955.png',
    'bankid-neg-72': 'bankid-neg-72-9f09838fd402c4311dd8fb0bd0288152c445fc1a.png',
    'bankid-neg-96': 'bankid-neg-96-f96178a3ad9fdb476b4113fda79d59ebb27ebbb3.png',
    'bankid-neg-142': 'bankid-neg-142-ec57780db4c98909a77345dd9f3890f0d4fd4a77.png',
    'bankid-neg-192': 'bankid-neg-192-9525e3ab28b23b355ea735d88a3cd3748f978c38.png',
    'bankid-neg-284': 'bankid-neg-284-2e79bf8378b9ba68f45d0086c6f9171a5ca4d944.png',
    'nordea': 'nordea-284-ba9ccd31980f1e229e2b05681c185c2bfb11556c.png',
    'nordea-24': 'nordea-24-b77be9f00a554ecb1414a7e0cef02dcfd09e1070.png',
    'nordea-36': 'nordea-36-ff4a19b3b83849b71beb3df78fa5b830680ddb8e.png',
    'nordea-48': 'nordea-48-0fa7136d551f7e3a716176b425885389bb366d4a.png',
    'nordea-72': 'nordea-72-691074ba4c2d4e6dd7e46c964b7a67ac79fd79a8.png',
    'nordea-96': 'nordea-96-f09f5f3f79ee450eec6a2c23b6b5017080aa200a.png',
    'nordea-142': 'nordea-142-df6d1ea7c25c3d0f57d18d58b253a0a5638a4a4f.png',
    'nordea-192': 'nordea-192-188b45bce3e4c757fbf9dd70f405a3b2df5bb589.png',
    'nordea-284': 'nordea-284-ba9ccd31980f1e229e2b05681c185c2bfb11556c.png',
    'payex-grey': 'payex-grey-284-36d1d83d0368b677abac7eecc9556746e09fa27d.png',
    'payex-grey-24': 'payex-grey-24-25fb3521305b6fa8434378748bebaff971c732f5.png',
    'payex-grey-36': 'payex-grey-36-54eec83588dee2aa4e066c2391f5be6d10757b79.png',
    'payex-grey-48': 'payex-grey-48-3ff462273ee57e89ff3a063bd1998033baff1616.png',
    'payex-grey-72': 'payex-grey-72-8df542685c7eb8b4dccb2766a549ed899674b7ef.png',
    'payex-grey-96': 'payex-grey-96-d5f6059c18ff9cce955259e7d65e9a26b9a68a79.png',
    'payex-grey-142': 'payex-grey-142-f3e034fcca5f6a772a714d5a65079c0cd0fec458.png',
    'payex-grey-192': 'payex-grey-192-868e5382fd46e5e2a31dba66354c31d7b8a54c6a.png',
    'payex-grey-284': 'payex-grey-284-36d1d83d0368b677abac7eecc9556746e09fa27d.png',
    'payex': 'payex-284-6b9548a461d3fadcaa9a71724a48b79a9be327b3.png',
    'payex-24': 'payex-24-818280d06ffc67a0149c437bcb9234190c53d996.png',
    'payex-36': 'payex-36-e52e8f49d2e1ffd8c124862dca3f9ed9c1ab92cc.png',
    'payex-48': 'payex-48-b84a8dab59ede5ffe73b68bd447b69b4864ce671.png',
    'payex-72': 'payex-72-30ecd26846fe58927dd42b6cc5e76820628575f6.png',
    'payex-96': 'payex-96-c0df6d3fcf7fde4a96f37a862a9ca25f6a02e22b.png',
    'payex-142': 'payex-142-abe157bc5b79d7f9619c8db8f3df996e8b9878c9.png',
    'payex-192': 'payex-192-cf75ae4b447621b6638c5bc5b320fcfddb54ab88.png',
    'payex-284': 'payex-284-6b9548a461d3fadcaa9a71724a48b79a9be327b3.png',
    'seb': 'seb-284-f35b43e21595c1f03f729541ea732584570c815c.png',
    'seb-24': 'seb-24-835c29445e679895ec53225cd4c7752d00a6434e.png',
    'seb-36': 'seb-36-c4ae526532fc3da2db7e470ddb2fd664b5b35c03.png',
    'seb-48': 'seb-48-878afdd4444594ecf577f8ddf5609448ba6450fa.png',
    'seb-72': 'seb-72-74573579a257cfaae9ed9ba389d26111bc6a6c28.png',
    'seb-96': 'seb-96-654693b27ccf01dd9edcfcd73926f77a09d21a60.png',
    'seb-142': 'seb-142-5d2c858e35f4bd1e874563030d3e0d7dc493378e.png',
    'seb-192': 'seb-192-d31f4a99aaf5b8e7c4838a4cbf4e7984b344e308.png',
    'seb-284': 'seb-284-f35b43e21595c1f03f729541ea732584570c815c.png',
    'swedbank': 'swedbank-284-04c033a2d3cfd0b057546e71c039ee26b2f1b67d.png',
    'swedbank-24': 'swedbank-24-4d4e03d00d1f8a4fee68a859ccdfce130adf0ddd.png',
    'swedbank-36': 'swedbank-36-4d30e029e441f3f3a99d2f54e084b06f278d37d3.png',
    'swedbank-48': 'swedbank-48-f1f316fe47ba43a3bc01b9b4ede41bede353f843.png',
    'swedbank-72': 'swedbank-72-25485de7fffffd56ad43014f2943837ec5166c7b.png',
    'swedbank-96': 'swedbank-96-ca3540619af5d407547c13af074ccaaabccadf9c.png',
    'swedbank-142': 'swedbank-142-9d05e0a21fb47afc1658c66b5dcc04b7903f4cb3.png',
    'swedbank-192': 'swedbank-192-332649303cfa89b92575a26afbe2642ab610f4a3.png',
    'swedbank-284': 'swedbank-284-04c033a2d3cfd0b057546e71c039ee26b2f1b67d.png',
    'swish-grey': 'swish-grey-284-5c43ab627460fe0684ac94d608c68cb5d7e3f852.png',
    'swish-grey-24': 'swish-grey-24-944b921007c3209dfd7a11a04331a9852f1ee3e5.png',
    'swish-grey-36': 'swish-grey-36-d90c83df72aae0da778554bed11f7b791ab82d72.png',
    'swish-grey-48': 'swish-grey-48-894ce9756c3604079f80ec2d993ea978b019a072.png',
    'swish-grey-72': 'swish-grey-72-8a7484af155c7dbfa597b46139c12be08c160506.png',
    'swish-grey-96': 'swish-grey-96-a125856c420541d0a236bd6f0453ddee52e2897e.png',
    'swish-grey-142': 'swish-grey-142-06808131c9720b50c4bad0b4261fb93f7ad4b957.png',
    'swish-grey-192': 'swish-grey-192-1658bee1054a7f3f38cdcbc2708f34f9e54534aa.png',
    'swish-grey-284': 'swish-grey-284-5c43ab627460fe0684ac94d608c68cb5d7e3f852.png',
    'swish-neg': 'swish-neg-284-4b1b6e6774e6b97ea5caff5431c2215e3c25dfd6.png',
    'swish-neg-24': 'swish-neg-24-38f300330f7e945325ac2a66cacedd66e3f41d2c.png',
    'swish-neg-36': 'swish-neg-36-8a862978e62892b00b827d2c538b48aa0668c712.png',
    'swish-neg-48': 'swish-neg-48-efdc36288216cdb2d87f7d87ea3e47e8ed5385d8.png',
    'swish-neg-72': 'swish-neg-72-e886132830893be52e97241438fcc0c2af2a7143.png',
    'swish-neg-96': 'swish-neg-96-2a0cef472e3059c0df9150f7b2ec1309a76685aa.png',
    'swish-neg-142': 'swish-neg-142-b25208850ad1fefae4f4dab4d071e364efcab90a.png',
    'swish-neg-192': 'swish-neg-192-1b611e319e2a89319e5fc23ac5aaf6db02e69b95.png',
    'swish-neg-284': 'swish-neg-284-4b1b6e6774e6b97ea5caff5431c2215e3c25dfd6.png',
    'swish-promo': 'swish-promo-284-97c2c933387d3003ec4d817018137288533b25b7.png',
    'swish-promo-24': 'swish-promo-24-4e734e42138ea2883c1a1c8a61005ec11c0975fd.png',
    'swish-promo-36': 'swish-promo-36-c727ce1f9eee08be50dfdd46a37e35195be7b9c3.png',
    'swish-promo-48': 'swish-promo-48-f37a0a82891a1923dca90c2520c20f72ed890dca.png',
    'swish-promo-72': 'swish-promo-72-c1def5172ced4b710ffb51cd2ead00205470b3c6.png',
    'swish-promo-96': 'swish-promo-96-e7e046cdc0a2106c72b1aef1e4a79ee639f72ecd.png',
    'swish-promo-142': 'swish-promo-142-c14a5db2ad533d033e24545c9de435969ce3c033.png',
    'swish-promo-192': 'swish-promo-192-3b2961609768334c7fa98a557b877951220ef026.png',
    'swish-promo-284': 'swish-promo-284-97c2c933387d3003ec4d817018137288533b25b7.png',
    'swish': 'swish-284-6a2721302e1bb75d7cc93f6e51b60c3fdc567eb7.png',
    'swish-24': 'swish-24-b52c30d7158a17baf31bc7b2adc89b57c7b26316.png',
    'swish-36': 'swish-36-4bdafd03abbe424cb9f3ee0ec3892cdbf32597af.png',
    'swish-48': 'swish-48-97a8c5b5759ebe393eb447201337bdf44c3dad67.png',
    'swish-72': 'swish-72-d22677ca2d9230c966dfbc7b5e83fa12a42abbd3.png',
    'swish-96': 'swish-96-a27f364f9c141efcf82e9b2ec26059315dd55d1a.png',
    'swish-142': 'swish-142-4dcdc7f1d386d16ff92fde1b66c46c28b9f59084.png',
    'swish-192': 'swish-192-6f4c2783aa343d2ba892364f897b612bedd57a11.png',
    'swish-284': 'swish-284-6a2721302e1bb75d7cc93f6e51b60c3fdc567eb7.png',
    'verifiedbyvisa': 'verifiedbyvisa-284-94ad0dfef7af554ffb534b3563b934f2433787a2.png',
    'verifiedbyvisa-24': 'verifiedbyvisa-24-b2299a621b5427b34256a00010512df3cc674a65.png',
    'verifiedbyvisa-36': 'verifiedbyvisa-36-4d7d2626a8ee09ea83a2fce4f650cd30165a34b2.png',
    'verifiedbyvisa-48': 'verifiedbyvisa-48-3f9e17d2aa6ca9e662e84d60686b55858acb44a7.png',
    'verifiedbyvisa-72': 'verifiedbyvisa-72-358a3e6aaa0627687842b342aead55855a410010.png',
    'verifiedbyvisa-96': 'verifiedbyvisa-96-02147b07317cbc1dde48f9c1a0a2543684209965.png',
    'verifiedbyvisa-142': 'verifiedbyvisa-142-00122aab8959bfdae837afdfe2e2f12f1dd988dc.png',
    'verifiedbyvisa-192': 'verifiedbyvisa-192-42a79e7c75e1bcaadb19e626c6daad3ef72559e8.png',
    'verifiedbyvisa-284': 'verifiedbyvisa-284-94ad0dfef7af554ffb534b3563b934f2433787a2.png',
    'visa': 'visa-284-8481e67280fa95727038686bcbbbbe7aae4bdc97.png',
    'visa-24': 'visa-24-af6b5ffd09f7c3f6d0c499cafbdb8d8f69b77476.png',
    'visa-36': 'visa-36-25ee79b024c810917f00a2efc57141c67f11bfe0.png',
    'visa-48': 'visa-48-d337bf2f2bcd2102d02478fee7ba8302f41139df.png',
    'visa-72': 'visa-72-6306b035c2fb341affc64c7b6bfb9fde79df8601.png',
    'visa-96': 'visa-96-5f544e440a15b5369a844c8f1b7b93e8dedfb02b.png',
    'visa-142': 'visa-142-9678a03e26f3f35b344ff7eaa3292ef22e389b4e.png',
    'visa-192': 'visa-192-56b5e46b2ce95250bdd31b027d2509510b1ace03.png',
    'visa-284': 'visa-284-8481e67280fa95727038686bcbbbbe7aae4bdc97.png'
  };

  svs.ui.bank.getIMG = function (file, size) {
    var hashedStr,
        hashedStrRetina,
        cdn = config.options && config.options.cdn ? config.options.cdn : '',
        ret = {};

    if (hashedFiles[file] && size > 0) {
      hashedStr = hashedFiles[file + '-' + size] ? file + '-' + size : file;
      hashedStrRetina = hashedFiles[file + '-' + size * 2] ? file + '-' + size * 2 : file;
    }

    if (hashedFiles[hashedStr]) {
      ret = [cdn + path + hashedFiles[hashedStr], cdn + path + hashedFiles[hashedStrRetina]];
    }

    return ret;
  }; 


  if (isServerSide) {
    module.exports = svs.ui.bank;
  }
})(svs);
 })(window);